import { defineOrganization, useSchemaOrg } from '@unhead/schema-org/vue';
import { computed } from 'vue';
import {
    SOCIALS_LINK_FACEBOOK,
    SOCIALS_LINK_LINKEDIN,
    SOCIALS_LINK_INSTAGRAM,
    SOCIALS_LINK_TIKTOK,
    SOCIALS_LINK_YOUTUBE,
} from '@/utils/constants';

export function useOrganizationSchema() {
    const organizationSchema = computed(() => {
        return defineOrganization({
            name: 'Carista',
            url: 'https://www.carista.com',
            logo: 'https://www.carista.com/images/logo.png',
            description:
                'Carista OBD2 is a mobile app and OBD2 scanner that lets you diagnose vehicle issues, customize car features, and perform dealer-level service tasks.',
            email: 'support@caristaapp.com',
            sameAs: [
                SOCIALS_LINK_FACEBOOK,
                SOCIALS_LINK_LINKEDIN,
                SOCIALS_LINK_INSTAGRAM,
                SOCIALS_LINK_TIKTOK,
                SOCIALS_LINK_YOUTUBE,
            ],
            contactPoint: [
                {
                    '@type': 'ContactPoint',
                    email: 'support@carista.com',
                    contactType: 'customer service',
                },
            ],
        });
    });

    useSchemaOrg([organizationSchema.value]);

    return {
        organizationSchema,
    };
}
